import backofficeService from '../../api/backoffice'

export default {
  
  getAllActivities(params) {
    return backofficeService.Api().get('api/activity', { params } )
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  
  getAllLogs(params) {
    return backofficeService.Api().get('api/log', { params } )
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getAllFeedbacks(params) {
    return backofficeService.Api().get('api/ticket/feedback', { params } )
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getAllComments(params) {
    return backofficeService.Api().get('crm/api/comment', { params } )
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  
  getActivityByDate(){
    return backofficeService.Api().get(`api/activity/byDate`)
    .then(response =>{
      console.log('response is :', response)
      return response.data
    }).catch(error =>{
      throw error
    })
  },
}
